module.exports = __webpack_public_path__ + "static/media/darkorgange.cd0aa7d5.png";